import React from 'react'

import { FairUse, Span } from 'src/styled'

interface Props {
  messages?: string[]
}

const Disclaimer: React.FC<Props> = props => {
  const { messages } = props
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {messages && messages.map((message, i) => <Span key={i}>{message}</Span>)}
      <Span>
        All Heartfelt Prompting Cards are subject to the {''}
        <FairUse
          target="blank"
          href="https://www.sendoutcards.com/resources/documents/393/Fair_Use_Policy_July_1_2020.pdf"
          onClick={e => {
            e.stopPropagation()
          }}
        >
          Fair Use Policy
        </FairUse>{' '}
        and all prices are in USD.
      </Span>
    </div>
  )
}

export default Disclaimer
